import { render, staticRenderFns } from "./system.vue?vue&type=template&id=d6bab972&scoped=true"
import script from "./system.vue?vue&type=script&lang=js"
export * from "./system.vue?vue&type=script&lang=js"
import style0 from "./system.vue?vue&type=style&index=0&id=d6bab972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bab972",
  null
  
)

export default component.exports